import { create } from 'zustand';

interface NavigationState {
  isNavigationOpen: boolean;
}

const useNavigationStore = create<NavigationState>(() => ({
  isNavigationOpen: false,
}));

class NavStore {
  openNavigation() {
    useNavigationStore.setState({ isNavigationOpen: true });
  }

  closeNavigation() {
    useNavigationStore.setState({ isNavigationOpen: false });
  }

  toggleNavigation() {
    useNavigationStore.setState((state) => ({ 
      isNavigationOpen: !state.isNavigationOpen 
    }));
  }
}

export const navStore = new NavStore();
export { useNavigationStore };
